import React, { useState, useEffect, useCallback } from 'react';
import workflowService from '../services/workflowService';
import { FiPlusCircle, FiTrash2, FiEdit } from 'react-icons/fi'; // <-- ADD FiEdit
import WorkflowForm from '../components/workflows/WorkflowForm';

const WorkflowsPage = () => {
  const [workflows, setWorkflows] = useState([]);
  const [events, setEvents] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingWorkflow, setEditingWorkflow] = useState(null);
  const [error, setError] = useState('');
  const [modalError, setModalError] = useState('');

  const fetchData = useCallback(async () => {
    try {
      const [hooks, eventList] = await Promise.all([
        workflowService.getWorkflows(),
        workflowService.getWorkflowEvents()
      ]);
      setWorkflows(hooks);
      setEvents(eventList);
    } catch (err) {
      setError('Failed to load workflow data.');
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // --- MODIFIED FUNCTION ---
  const handleSave = async (workflowData) => {
    try {
      if (editingWorkflow) {
        await workflowService.updateWorkflow(editingWorkflow._id, workflowData);
      } else {
        await workflowService.createWorkflow(workflowData);
      }
      fetchData();
      setIsModalOpen(false);
      setEditingWorkflow(null);
      setModalError('');
    } catch (err) {
      setModalError(err.response?.data?.message || 'Failed to save workflow.');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this workflow?')) {
      try {
        await workflowService.deleteWorkflow(id);
        fetchData();
      } catch (err) {
        setError('Failed to delete workflow.');
      }
    }
  };

  // --- MODIFIED FUNCTION ---
  const openModal = async (workflow = null) => {
    if (workflow) {
      // Fetch the full, unmasked data for editing
      try {
        const fullWorkflow = await workflowService.getWorkflowById(workflow._id);
        setEditingWorkflow(fullWorkflow);
      } catch (err) {
        setError('Could not fetch workflow details for editing.');
        return;
      }
    } else {
      setEditingWorkflow(null);
    }
    setIsModalOpen(true);
    setError('');
    setModalError('');
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-800">Workflows</h1>
        <button onClick={() => openModal()} className="flex items-center bg-primary text-white px-4 py-2 rounded-md shadow hover:bg-primary-dark">
          <FiPlusCircle className="mr-2" /> New Workflow
        </button>
      </div>
      {error && <p className="bg-red-100 text-red-700 p-3 rounded mb-4">{error}</p>}
      <div className="bg-white shadow-md rounded-lg overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left">Name</th>
              <th className="px-4 py-3 text-left">Trigger</th>
              <th className="px-4 py-3 text-left">Action</th>
              <th className="px-4 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {workflows.map(flow => (
              <tr key={flow._id}>
                <td className="px-4 py-4 font-semibold">{flow.name}</td>
                <td className="px-4 py-4 font-mono text-sm">{flow.triggerType === 'EVENT' ? flow.event : 'Inbound Webhook'}</td>
                <td className="px-4 py-4 text-sm">{flow.actionType === 'CALL_API' ? `Call API: ${flow.config.url}` : `Internal Action: ${flow.config.entity}`}</td>
                <td className="px-4 py-4 text-right space-x-4">
                  {/* --- ADD EDIT BUTTON --- */}
                  <button onClick={() => openModal(flow)} className="text-indigo-600 hover:text-indigo-900"><FiEdit /></button>
                  <button onClick={() => handleDelete(flow._id)} className="text-red-600 hover:text-red-900"><FiTrash2 /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <WorkflowForm
          workflow={editingWorkflow}
          events={events}
          error={modalError}
          onSave={handleSave}
          onCancel={() => {
            setIsModalOpen(false);
            setModalError('');
          }}
        />
      )}
    </div>
  );
};

export default WorkflowsPage;
